import React, { useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import InputUI from "@UI/InputUI";

const SortableAddressItem = ({ id, index, address, onTextChange, onRemove, showRemove }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginBottom: "8px",
        padding: "8px",
        backgroundColor: isDragging ? "#f0f0f0" : "white",
        borderRadius: "4px",
        // border: "1px solid #ddd",
    };

    return (
        <div ref={setNodeRef} style={style} className="columns__block-input">
            <span style={{ minWidth: "20px" }}>{index + 1}</span>
            <InputUI value={address.text} style={{ flex: 1 }} onChange={(e) => onTextChange(e.target.value)} type="text" placeholder="Введите адрес" />
            {showRemove && (
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <i className="pi pi-trash" onClick={onRemove} style={{ color: "#FF3D32", cursor: "pointer" }} />
                    <i className="pi pi-arrows-v" style={{ color: "#000000", cursor: "grab" }} {...attributes} {...listeners} />
                </div>
            )}
        </div>
    );
};

export default SortableAddressItem;
